<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Validación gerente del área</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div style='text-align:justific' slot="header">
            <strong class="izquierda">Filtros del Informe</strong>
            <strong class="derecha">GARANTÍA</strong>
          </div>

          <b-row>
            <!-- <b-col sm="3">
              <b-form-group label="Tipo de Validación">
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="M">Validación Masiva</b-form-radio>
                <b-form-radio v-model="datosFormulario.selected" name="some-radios" value="I">Validación Individual</b-form-radio>
              </b-form-group>
            </b-col> -->
            <b-col sm="2">
              <b-form-group
                :label="crearLabel('Fecha Programada de Pago', 'fecpago', 'datosFormulario')"
                label-for="fecpago">
                <b-form-select 
                  :options="valFechas"  
                  v-model="datosFormulario.fecpago"
                  :disabled="campoBloqueado('fecpago', 'datosFormulario')"
                >
                </b-form-select>
                
                <span class="error-validacion-campo">
                  {{ mensajeValidacionCampo.fecpago }}
                </span>
              </b-form-group>
              
            </b-col>           
            
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                                <b-button variant="primary" @click="descargarExcel"><i class="fa fa-file-excel-o"></i> Exportar</b-button>
                                <b-button variant="success" @click="modalAutorizar = true" style="color: #ffffff; margin-left: 10px;" v-show="datosFormulario.selected == 'M'? true : false">
                                  <i class="fa fa-save"></i> Autorizar
                                </b-button>
                                <b-button variant="danger" @click="modalRechazar = true" style="color: #ffffff; margin-left: 10px;" v-show="datosFormulario.selected == 'M'? true : false">
                                  <i class="fa fa-save"></i> Rechazar
                                </b-button>
                            </el-col> 
                               
                    </el-row>                
                </div>
            </div>            
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>  
        <b-card v-if="mostrarInfo">
          <div>
          <b-alert variant="info" show>
            Número total de casos <strong>Autorizados</strong> para la fecha seleccionada <strong>({{datosFormulario.autorizados}})</strong>.
            <br>
            Número total de casos <strong>Pendientes</strong> para la fecha seleccionada <strong>({{datosFormulario.pendientes}})</strong>.
            <br>
            Número total de casos <strong>Rechazados</strong> para la fecha seleccionada <strong>({{datosFormulario.rechazados}})</strong>.
          </b-alert>
          </div>            
        </b-card>
      </b-col>
    </b-row>

    <b-card v-if="tieneAcceso === true" v-show="datosFormulario.selected == 'M'? true : false">
          <div slot="header">
            <strong>Validación Gerente del Area</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @selection-change="handleSelectionChange">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                 
                <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="DocContishare(scope.row.SINIESTRO, scope.row)">Ver</el-button>   
                  </template>
                </el-table-column>
                
                <el-table-column  type="selection" width="35" reserve-selection><!-- reserve-selection -->
                </el-table-column>
                
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-card>

    <b-card v-if="tieneAcceso === true" v-show="datosFormulario.selected == 'I'? true : false">
          <div slot="header">
            <strong>Validación Gerente del Area</strong>
          </div>
          <b-row>
            <b-col lg="6"></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable1B"
                  :data="data"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table">
                >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    sortable="custom"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                    
                  >
                  </el-table-column>
                  <el-table-column label="Documentación" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRowDoc(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>
                  <el-table-column label="Revisión GS" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                  </el-table-column>
                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-card>

    <!-- Observacion -->
    <b-modal
      title="Observación"
      cancel-title="Omitir"
      ok-title="Guardar"
      class="modal-success"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      v-model="modalObservacion"
      @ok="confirmaRechazo(true);"
      @cancel="confirmaRechazo(false)"
    >
      <b-form-textarea
        id="obs"
        v-model="modalDataObservacion.observacion"
        placeholder="Ingrese la observación (Opcional)."
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

    <!-- Autorizacion Masiva -->
    <b-modal
      title="Autorización Masiva"
      cancel-title="Cancelar"
      ok-title="Autorizar"
      class="modal-success"
      v-model="modalAutorizar"
      @ok="autorizar();"
      @cancel="modalAutorizar = false"
    >
        Se autorizaran todos los registro marcados.  
    </b-modal>

    <!-- Rechazar Masiva -->
    <b-modal
      title="Rechazar Masivo"
      cancel-title="Cancelar"
      ok-title="Rechazar"
      class="modal-success"
      v-model="modalRechazar"
      @ok="rechazarMasivo();"
      @cancel="modalRechazar = false"
    >
        Se rechazaran todos los registro marcados.  
    </b-modal>

    <!-- Detalle Documentación de Contishare -->
    <b-modal
      size="lg"
      hide-footer
      title="Documentación de Contishare"
      cancel-title="Cerrar"
      ok-title="Guardar"
      class="modal-success"
      v-model="modalDocContishare"
      @ok="guardarLinkContishare();"
      @cancel="modalDocContishare = false"
    >
      <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTable3"
                  :data="dataDocContishare"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps2"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  @select="handleSelectionChange2"
                  @select-all="selectAll"                  
                >
                  <el-table-column
                    v-for="title in titlesDocContishare"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    name="table"
                    class="table-responsive"
                  ></el-table-column>
                  
                  <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="verDocumento(scope.row.LINK)">Ver</el-button>   
                  </template>
                  </el-table-column>

                  <!-- <el-table-column type="selection" width="35" reserve-selection>
                  </el-table-column> -->


                  <el-table-column label="" min-width="10px" align="center">
                  </el-table-column>

                </data-tables>
              </div>
            </b-col>
          </b-row>
    </b-modal>

  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiGarValindemn from "@/components/services/apiGarValindemn";
import apiGarNomina from "@/components/services/apiGarNomina";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import numeral from "numeral";

import XLSX from "xlsx";

export default {
  name: "validacióngerentedelárea",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      exportar: false,
      tieneAcceso: true,
      mostrarInfo: false,
      modalDocContishare: false,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      data: [],
      dataDetalle: [],
      dataDocContishare: [],
      nombreexcel: "Validación Gerente del Area",
      titles: [
        {
          prop: "PRODUCTO",
          label: "Producto",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "POLIZA",
          label: "Póliza",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "SINIESTRO",
          label: "Siniestro",
          align: "center",
          minwidth: "120",
        },
        {
          prop: "AFIANZADO",
          label: "Afianzado",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "BENEFICIARIO",
          label: "Beneficiario",
          align: "left",
          minwidth: "300",
        },
        {
          prop: "EJECUTIVO",
          label: "Ejecutivo",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONEDA",
          label: "Moneda",
          align: "center",
          minwidth: "100",
        },
        {
          prop: "MONTO",
          label: "Monto a indemnizar",
          align: "right",
          minwidth: "200",
        },
        {
          prop: "VBGSDESC",
          label: "Estado",
          align: "center",
          minwidth: "120",
        },
      ],

      titlesDocContishare: [
        {
          prop: "CSHTITULO",
          label: "Categoría - Nombre del Documento",
          align: "left",
          minwidth: "250",
        },        
      ],
      
      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      titlesDetalle: [
        {
          prop: "Item",
          label: "Item",
          align: "left",
        },
        {
          prop: "Monto $",
          label: "Monto $",
          align: "right",
          minwidth: "50",
        },
        {
          prop: "Moneda",
          label: "Moneda Póliza",
          align: "center",
        },
        {
          prop: "Monto Moneda Póliza",
          label: "Monto Moneda Póliza",
          align: "right",
          minwidth: "70",
        }
      ],
      filters2: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'Fecha Est. Config'){
                let elDate = new Date(row["Fecha Est. Config"])
                let newdate = moment(elDate).add(1, 'days').format('DD/MM/YYYY');
                return newdate.indexOf(filter.value) > -1
              } else {
                return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
              }
            })
            
          }
        }
      ],

      valFechas: [],
      
      datosFormulario: {
        fecpago: "",
        selected: "",
        pendientes: 0,
        autorizados: 0,
        rechazados: 0,
      },

      datosFormularioDetalle: {
        coaseguro: "",
        parte_cubierta: "", 
        tipo: "",
        fecha_publicacion: "",
        monto_impto: "",
        no_nd: "",
        observaciones: "",
        fecha: "",
        instancia: "",
        porc: "",
        monto: "",
        obsexec: ""
      },

      

      datosFormularioEstado: [],
      mensajeValidacionCampo: {},
      modalDataDetalle: {},

      modalObservacion: false,
      modalDataObservacion: {
        observacion: "",
        siniestro: "",
        individual: true
      },

      modalAutorizar: false,
      modalRechazar: false,

      multipleSelection: [],

      tableProps2: {
        summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
        rowKey: "Siniestro",

        rowClassName({ row, rowIndex}) {
          
            if(row.VBGS == "R"){
                return 'warning-row';
            } else if (row.FECHA != null && row.ESTADO == "1" && row.NOMINA =="1" && row.VBGS == "Q"){
              return 'danger-row';
            }else{
                return 'estiloFilaTabla';
            }
        }
      },
    };
  },
  components:{
    Datepicker
  },
  methods: {
    customButtonsForRowDoc(row) {
          var botones = new Array();
          
          if (row.INFORME)
          {
            var obj = new Object();
            obj.tooltip = "Informe Liquidación";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-file-pdf-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.INFORME, '_blank');
            }
            botones.push(obj);
          }

          if (row.CORREO)
          {
            var obj = new Object();
            obj.tooltip = "Correo";
            obj.id = 2;
            obj.name="";
            obj.icon = "fa fa-envelope-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                window.open(row.CORREO, '_self');
            }
            botones.push(obj);
          }
          
          return botones;

    },

    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Detalle del Siniestro";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-pencil-square-o";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.buscar_detalle(row);
            }
            botones.push(obj);
          
          
          return botones;

    },

    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.refTable1.$children[0].toggleRowSelection(row);
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    
    handleSelectionChange2(selection, row) {

      this.nomdoccontish = row.CSHTITULO;
      this.linkdoccontish = row.LINK;

      // this.link = row
      // debugger;
      if (selection.length > 1 ) {
            this.crearNotificacion("Error de sistema", "Solo se puede seleccionar un solo registro", "error");
            this.$refs.refTable3.$children[0].toggleRowSelection(row, false);
            return;
           }
    },

    selectAll(rows){
      this.$refs.refTable3.$children[0].clearSelection();
      return;
    },

    mergeArrayObjects(arr1,arr2){
      return arr1.map((item,i)=>{
        if(item.id === arr2[i].id){
            //merging two objects
          return Object.assign({},item,arr2[i])
        }
      })
    },

    formatNumber(n) {
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

    totales(param) {
 
      const { columns, data } = param;

      const sums = [];

      columns.forEach((column, index) => {
          if (index === 0) {
              sums[index] = 'Total';
              return;
          }

          const values = data.map(item => Number(item[column.property]));

          if (!values.every(value => isNaN(value))) {
              
              sums[index] = this.$numeral((values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0))).format();
              
             /*
             sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);

                  if (!isNaN(value)) {
                      return prev + curr;
                  } else {
                      return prev;
                  }
              }, 0);
              */
          } else {
              sums[index] = '';
          }
      });

      return sums;
    },

    DocContishare(siniestro, row){
      this.$Progress.start();
      return apiGarNomina
        .DocContishare(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          siniestro
        )
        .then((response) => {
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
          this.dataDocContishare = response.data.res1;
          this.datalink = row;
          this.modalDocContishare = true;
          
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    verDocumento(link) {
      window.open(link, '_blank');
    },

    guardarLinkContishare(){

      apiGarNomina
          .guardar_link_contishare(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datalink.Siniestro,
            this.linkdoccontish,
            this.nomdoccontish
          )
          .then(response => {
            if (response.data.festado.resultado.estado != "error"){
              this.crearNotificacion(
                "Link Contishare",
                "Link de Contishare guardada con éxito.",
                "success"
              ); 
            }
            else{
              this.crearNotificacion("Error de sistema", response.data.festado.resultado.mensaje, "error");
            }
            
            this.modalObservacion = false;
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    exportarExcel() {
        this.$nextTick(function() {
          var tabla = document.getElementById("tableExcel");
          var data = XLSX.utils.table_to_sheet(tabla);
          const workbook = XLSX.utils.book_new();
          const filename = "Export";
          XLSX.utils.book_append_sheet(workbook, data, filename);
          XLSX.writeFile(workbook, `${filename}.xlsx`);
        });
    },
    
    pre_insertar() {
      this.mostrarInfo = false;
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.data3 = [];
      return apiGarValindemn
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno")
        )
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
          }else{
            this.tieneAcceso = false;
          }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.fecpago = this.convierteFecha(lista_data[i]["fecpago"]);
              this.datosFormulario.selected = lista_data[i]["tipoval"];
              this.datosFormulario.pendientes = lista_data[i]["pendientes"];
              this.datosFormulario.autorizados = lista_data[i]["autorizados"];
              this.datosFormulario.rechazados = lista_data[i]["rechazados"];
          }
         
      
          this.datosFormularioEstado = response.data.festado;
          
          //Carga lista de ejecutivos
          var tiposFecha = new Array();
          var lista_tipos_fecha = response.data.fechas;
          for(var i = 0; i < lista_tipos_fecha.length; i++){
              var obj = new Object();
              obj.value = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              obj.text = this.convierteFecha(lista_tipos_fecha[i]["snpfecha"]);
              tiposFecha.push(obj);
          }
          this.valFechas = tiposFecha;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();
      return apiGarValindemn
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario.fecpago, 
          this.datosFormulario.selected
        )
        .then(response => {
          this.data  = response.data.res;
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();

          this.datosFormulario.pendientes = response.data.args_out.pendientes;
          this.datosFormulario.autorizados = response.data.args_out.autorizados;
          this.datosFormulario.rechazados = response.data.args_out.rechazados;

          if (this.data != null){
            this.mostrarInfo = true;
            this.exportar = true;
          } else {
            this.exportar = false;
          }
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar_detalle(row) {
      this.$Progress.start();
      this.modalDataDetalle = row;
      return apiGarValindemn
        .recuperar_detalle(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          row.SINIESTRO
        )
        .then(response => {
          this.dataDetalle  = response.data.res;
          
          this.datosFormularioDetalle.coaseguro = "";
          this.datosFormularioDetalle.parte_cubierta = "";
          this.datosFormularioDetalle.tipo = "";
          this.datosFormularioDetalle.fecha_publicacion = "";
          this.datosFormularioDetalle.monto_impto = "";
          this.datosFormularioDetalle.no_nd = "";
          this.datosFormularioDetalle.observaciones = "";
          this.datosFormularioDetalle.fecha = "";
          this.datosFormularioDetalle.instancia = "";
          this.datosFormularioDetalle.porc = "";
          this.datosFormularioDetalle.monto = "";
          this.datosFormularioDetalle.obsexec = "";

          var lista_data = response.data.res2;
          
          for (var i = 0; i < lista_data.length; i++) {
            
            if (lista_data[i]["nombre"] == 'coaseguro'){
              this.datosFormularioDetalle.coaseguro = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'parte_cubierta'){
              this.datosFormularioDetalle.parte_cubierta = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'tipo'){
              this.datosFormularioDetalle.tipo = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'fecha_publicacion'){
              this.datosFormularioDetalle.fecha_publicacion = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'monto_impto'){
              this.datosFormularioDetalle.monto_impto = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'no_nd'){
              this.datosFormularioDetalle.no_nd = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'observaciones'){
              this.datosFormularioDetalle.observaciones = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'fecha'){
              this.datosFormularioDetalle.fecha = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'instancia'){
              this.datosFormularioDetalle.instancia = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'porc'){
              this.datosFormularioDetalle.porc = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'monto'){
              this.datosFormularioDetalle.monto = lista_data[i]["valor"];
            }
            if (lista_data[i]["nombre"] == 'obsexec'){
              this.datosFormularioDetalle.obsexec = lista_data[i]["valor"];
            }
          }

          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          this.modalDetalle = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      if (column.property == "prifmodif" && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      } else if (column.property == "Monto $" && row[column.property] ||
                 column.property == "Monto Moneda Póliza" && row[column.property]) {
        column.align = "is-right";
        
        return this.$numeral(row[column.property]).format("0,0.00");
      } else {
        return row[column.property];
      }
      
    },
    
    descargarExcel: function () {
      var cuerpo = "";
      var columnas = this.titles;

      var xl159618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl689618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; background:#BDD7EE; mso-pattern:black none; white-space:nowrap;";
      var xl649618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl679618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:400; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";
      var xl719618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:12.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:center; vertical-align:middle; border-top:.5pt solid windowtext; border-right:.5pt solid windowtext; border-bottom:.5pt solid windowtext; border-left:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap; mso-rotate:90;";
      var xl659618 =
        "padding:0px; mso-ignore:padding; color:black; font-size:11.0pt; font-weight:700; font-style:normal; text-decoration:none; font-family:Calibri, sans-serif; mso-font-charset:0; mso-number-format:General; text-align:general; vertical-align:bottom; border:.5pt solid windowtext; mso-background-source:auto; mso-pattern:auto; white-space:nowrap;";

      cuerpo +=
        "<table border=0 cellpadding=0 cellspacing=0 width=730 style='border-collapse:collapse;table-layout:fixed;width:550pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=32 style='mso-width-source:userset;mso-width-alt:1170;width:24pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=130 style='mso-width-source:userset;mso-width-alt:4754;width:98pt'>";
      cuerpo += "\n";
      cuerpo +=
        "<col width=61 span=8 style='mso-width-source:userset;mso-width-alt:2230; width:46pt'>";
      cuerpo += "\n";
      cuerpo += "<col width=80 style='width:60pt'>";
      cuerpo += "\n";

      cuerpo +=
        "<tr height=28 style='mso-height-source:userset;height:21.0pt'>\n";
      //cuerpo += "<td height=28 class=xl159618 style='height:21.0pt;"+xl159618+"'></td>\n";
      cuerpo +=
        "<td colspan=" +
        columnas.length +
        " class=xl689618 style='border-right:.5pt solid black;" +
        xl689618 +
        "' >Validación gerente del area al " +
        this.datosFormulario.fecpago +
        "</td>\n";
      cuerpo += "</tr>\n";

      cuerpo += "<tr height=20 style='height:15.0pt'>\n";
      //cuerpo += "<td height=20 class=xl159618 style='height:15.0pt;"+xl159618+"'></td>\n";
      for (var i = 0; i < columnas.length; i++) {
        cuerpo +=
          "<td class=xl679618 style='border-left:none;" +
          xl679618 +
          "'>" +
          columnas[i].label +
          "</td>\n";
      }
      cuerpo += "</tr>\n";
      
      //Data bloque 1
      for (var key in this.data) {
        if(this.data[key]["PRODUCTO"] == undefined){
          this.data[key]["PRODUCTO"] = "";
        }
        if(this.data[key]["POLIZA"] == undefined){
          this.data[key]["POLIZA"] = "";
        }
        if(this.data[key]["SINIESTRO"] == undefined){
          this.data[key]["SINIESTRO"] = "";
        }
        if(this.data[key]["AFIANZADO"] == undefined){
          this.data[key]["AFIANZADO"] = "";
        }
        if(this.data[key]["BENEFICIARIO"] == undefined){
          this.data[key]["BENEFICIARIO"] = "";
        }
        if(this.data[key]["EJECUTIVO"] == undefined){
          this.data[key]["EJECUTIVO"] = "";
        }
        if(this.data[key]["MONEDA"] == undefined){
          this.data[key]["MONEDA"] = "";
        }
        if(this.data[key]["MONTO"] == undefined){
          this.data[key]["MONTO"] = "";
        }
        if(this.data[key]["VBGSDESC"] == undefined){
          this.data[key]["VBGSDESC"] = "";
        }
        

        cuerpo +="<tr height=20 style='mso-height-source:userset;height:15.0pt'>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["PRODUCTO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["POLIZA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["SINIESTRO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["AFIANZADO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["BENEFICIARIO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["EJECUTIVO"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["MONEDA"] + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.$numeral(this.data[key]["MONTO"]).format("0,0.00") + "</td>\n";
        cuerpo += "<td class=xl649618 style='border-top:none;border-left:none;" + xl649618 + "'>" + this.data[key]["VBGSDESC"] + "</td>\n";
        cuerpo += "</tr>\n";
      }

      this.export(
        this.generaExcelV2(this.nombreexcel, cuerpo),
        this.nombreexcel
      );
    },

    export:async function(data, filename) {
        if(typeof this.beforeFinish === 'function')
          await this.beforeFinish();
        download(data, filename,  "application/vnd.ms-excel");
      },

    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    autorizarIndividual(){
      this.$Progress.start();
      this.modalDetalle = false;
        
        apiGarValindemn
          .autorizar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.modalDataDetalle.SINIESTRO
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Autorizar",
                "Se han guardado las autorizaciones seleccionas.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
    },

    autorizar(){
      this.$Progress.start();

      /* solo los marcados y filtrados */
      var filtrados = this.$refs.refTable1.tableData;
      const names = filtrados.map(el => el.SINIESTRO);
      var marcados = new Array();

      for (var index = 0; index < this.multipleSelection.length; ++index) {
          if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
            marcados.push(this.multipleSelection[index]);
          }
      }
      /* -- */

      var siniestrosMarcados = "";
      var index = 0;
      for (index = 0; index < marcados.length; ++index) {
          siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
      }
      

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarValindemn
          .autorizar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Autorizar",
                "Se han guardado las autorizaciones seleccionas.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

    rechazarMasivo(){
      this.modalDataObservacion.observacion = "";
      this.modalDataObservacion.individual = false;
      this.modalDataObservacion.siniestro = "";
      this.modalRechazar = false;
      this.modalObservacion = true;
    },

    rechazarIndividual(){
      this.modalDataObservacion.observacion = "";
      this.modalDataObservacion.individual = true;
      this.modalDataObservacion.siniestro = this.modalDataDetalle.SINIESTRO;
      this.modalDetalle = false;
      this.modalObservacion = true;
    },

    confirmaRechazo(obs){
      
      this.$Progress.start();
      var siniestrosMarcados = "";
      var index = 0;
      var observacion = "";

      if (obs){
        observacion = this.modalDataObservacion.observacion;
      }

      if (this.modalDataObservacion.individual){
        siniestrosMarcados = this.modalDataObservacion.siniestro + ',';
      }
      else{

        /* solo los marcados y filtrados */
        var filtrados = this.$refs.refTable1.tableData;
        const names = filtrados.map(el => el.SINIESTRO);
        var marcados = new Array();

        for (var index = 0; index < this.multipleSelection.length; ++index) {
            if (names.includes(this.multipleSelection[index]["SINIESTRO"])){
              marcados.push(this.multipleSelection[index]);
            }
        }
        /* -- */

        for (index = 0; index < marcados.length; ++index) {
          siniestrosMarcados += marcados[index]["SINIESTRO"] + ',';
        }
      }

      if (siniestrosMarcados != ""){
        siniestrosMarcados = siniestrosMarcados.slice(0, -1)
        apiGarValindemn
          .rechazar(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            siniestrosMarcados,
            observacion
          )
          .then(response => {
            this.$Progress.finish();
            this.crearNotificacion(
                "Rechazar",
                "Se han guardado los rechazos seleccionados.",
                "success"
              );
            this.buscar();
          })
          .catch(error => {
            this.$Progress.finish();
            this.crearNotificacion("Error de sistema", error, "error");
            return;
          });
      }
    },

  },
  
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    data: function() {
      this.$nextTick(function() {
        this.$refs.refTable1.$children[0].clearSelection();
        // var lista = this.data;
        // var index = 0;
        // for (index = 0; index < lista.length; ++index) {
        //     this.toggleSelection([lista[index]]);
        // }
      })
    }
  }
};
</script>


<style scoped>

.derecha   { 
  float: right; 
  color: #20a8d8;
}
.izquierda { 
  float: left;  
}

.modal-xl {
  max-width: 90% !important;
}


</style>